<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />


    <div v-show="!modoVisualizacao">
        <div class="form-edit-page row row-space">
            <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" ref="dateRangeSelect" /></div>
            <div class="form-item">
                <PessoaFrame v-model:objSelecionado="pessoaSelecionada"/>
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        
        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th class="col-width-date">Data</th>
                        <th class="col-width-char10">Nro NF</th>
                        <th class="col-width-char10">Tipo</th>
                        <th>Nome</th>
                        <th class="col-width-char30">Fornecedor</th>
                        <th class="col-width-char15">Valor</th>
                        <th class="col-width-char20">Situação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}" 
                        @click="setVisualizar(obj)">
                        <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtregistro) }}</td>
                        <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.dfnumero) }}</td>
                        <td class="col-width-char10 center">{{ `${obj.tpnota} / ${obj.dfmodelo ?? ''}` }}</td>
                        <td>{{ obj.nmpessoa }}</td>
                        <td class="col-width-char30">{{ obj.nmfornecedor }}</td>
                        <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.dfvalor) }}</td>
                        <td class="col-width-char20">{{ obj.nmstatus }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoVisualizacao">
        <NotasFiscaisViewPage :idView="idView" @close="modoVisualizacao = false" />
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import NotasFiscaisViewPage from './NotasFiscaisViewPage.vue';
import PessoaFrame from '@/components/frames/PessoaFrame.vue';

const emit= defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const dateRangeSelect = ref(null);
const errorMessage = ref(null);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const lsDadosMain = ref([]);
const modoVisualizacao = ref(false);
const pessoaSelecionada = ref(null);
const showPagination = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        errorMessage.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/notas', {
            idmunicipio: globalStore.idmunicipio,
            idprograma: globalStore.idprograma,
            idpessoa: pessoaSelecionada.value?.id,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

const setVisualizar = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}
</script>
